import { render, staticRenderFns } from "./FileUploadWithSelectToOcpbCare.vue?vue&type=template&id=8b2add08&"
import script from "./FileUploadWithSelectToOcpbCare.vue?vue&type=script&lang=js&"
export * from "./FileUploadWithSelectToOcpbCare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports